"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelWrapper = exports.InvisibleWrapper = exports.ErrorWrapper = exports.ErrorLabel = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _proptypes = require("../Input/proptypes");
var _excluded = ["hasError", "numberOfErrors"];
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var styles = {
  "errorWrapper": "u-53ct",
  "hasError": "tJF5n6",
  "invisibleWrapper": "js7-tc",
  "labelWrapper": "qGKDhh",
  "errorLabel": "gptiJm",
  "inverse": "RKzarT"
};
var ErrorWrapper = exports.ErrorWrapper = function ErrorWrapper(_ref) {
  var hasError = _ref.hasError,
    numberOfErrors = _ref.numberOfErrors,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: (0, _clsx["default"])(styles.errorWrapper, hasError && styles.hasError),
    style: _objectSpread({}, hasError && {
      '--number-of-errors': numberOfErrors
    }),
    "data-testid": "ErrorWrapper"
  }, rest));
};
ErrorWrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  hasError: _propTypes["default"].bool,
  numberOfErrors: _propTypes["default"].number
} : {};
var InvisibleWrapper = exports.InvisibleWrapper = function InvisibleWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement("span", _extends({
    className: styles.invisibleWrapper
  }, props));
};
var LabelWrapper = exports.LabelWrapper = function LabelWrapper(props) {
  return /*#__PURE__*/_react["default"].createElement("div", _extends({
    className: styles.labelWrapper
  }, props));
};
var ErrorLabel = exports.ErrorLabel = function ErrorLabel(props) {
  return /*#__PURE__*/_react["default"].createElement(_Typography["default"], _extends({
    className: (0, _clsx["default"])(styles.errorLabel, (props === null || props === void 0 ? void 0 : props['data-variant']) === _proptypes.InputVariants.INVERSE && styles.inverse)
  }, props));
};
ErrorLabel.propTypes = process.env.NODE_ENV !== "production" ? {
  'data-variant': _propTypes["default"].oneOf(Object.values(_proptypes.InputVariants))
} : {};